import request from '../../axios';

const getStoreCommentsAndRateCounts = async () => {
  const {data}: {data: ICoomentsAndRateCounts} = await request.get(
    'api/v2/store/comments-rates-count',
  );
  return data;
};

export default getStoreCommentsAndRateCounts;
